import { AccessProfileMembershipReport } from 'components/pages/explore/query/AccessProfileMembershipReport'
import { AccountsWithoutOwner } from 'components/pages/explore/query/AccountsWithoutOwner'
import { ActiveExternalAccountsReport } from 'components/pages/explore/query/ActiveExternalAccountsReport'
import { AllAppUsersReport } from 'components/pages/explore/query/AllAppUsersReport'
import {
    AppEntitlementsWithDeactivatedOwnerReport,
} from 'components/pages/explore/query/AppEntitlementsWithDeactivatedOwnerReport'
import { AppEntitlementsWithOneOwnerReport } from 'components/pages/explore/query/AppEntitlementsWithOneOwnerReport'
import { AppResourcesWithDeactivatedOwnerReport } from 'components/pages/explore/query/AppResourcesWithDeactivatedOwnerReport'
import { AppsWithDeactivatedOwnersReport } from 'components/pages/explore/query/AppsWithDeactivatedOwnersReport'
import { AppsWithOneOwnerReport } from 'components/pages/explore/query/AppsWithOneOwnerReport'
import { HighRiskAccountsReport } from 'components/pages/explore/query/HighRiskAccountsReport'
import {
    HighRiskRoleGrantsReportPermanent, HighRiskRoleGrantsReportTemporary,
} from 'components/pages/explore/query/HighRiskRoleGrantsReport'
import { InactiveUsersReport } from 'components/pages/explore/query/InactiveUsersReport'
import { OrphanedAccountsReport } from 'components/pages/explore/query/OrphanedAccountsReport'
import { PastGrantsReport } from 'components/pages/explore/query/PastGrantsReport'
import { QUERIES } from 'components/pages/explore/query/Query'
import { Resources } from 'components/pages/explore/query/Resources'
import { StandingPrivilegesReport } from 'components/pages/explore/query/StandingPrivilegesReport'
import { UsersWithoutManagerReport } from 'components/pages/explore/query/UsersWithoutManagerReport'
import {
    UsersWithUnspecifiedEmploymentStatusReport,
} from 'components/pages/explore/query/UsersWithUnspecifiedEmploymentStatus'
import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'

export type ReportType = {
    query: string,
    params?: Record<string, string>,
}

export const Report: FC<ReportType> = ({ query }: ReportType): React.ReactElement => {
    switch (query) {
        case QUERIES.AccessProfileMembership:
            return <AccessProfileMembershipReport />
        case QUERIES.AllAppUsers:
            return <AllAppUsersReport />
        case QUERIES.HighRiskRoleGrantsPermanent:
            return <HighRiskRoleGrantsReportPermanent />
        case QUERIES.HighRiskRoleGrantsTemporary:
            return <HighRiskRoleGrantsReportTemporary />
        case QUERIES.UsersWithoutManager:
            return <UsersWithoutManagerReport />
        case QUERIES.UsersWithUnspecifiedEmploymentStatus:
            return <UsersWithUnspecifiedEmploymentStatusReport />
        case QUERIES.AppUsersWithoutOwner:
            return <AccountsWithoutOwner />
        case QUERIES.AppEntitlementsWithOneOwner:
            return <AppEntitlementsWithOneOwnerReport />
        case QUERIES.AppEntitlementsWithDeactivatedOwner:
            return <AppEntitlementsWithDeactivatedOwnerReport />
        case QUERIES.OrphanedAccounts:
            return <OrphanedAccountsReport />
        case QUERIES.HighRiskAccounts:
            return <HighRiskAccountsReport />
        case QUERIES.StandingPrivileges:
            return <StandingPrivilegesReport />
        case QUERIES.Resources:
            return <Resources />
        case QUERIES.AppUsersNotLoggedInRecently:
            return <InactiveUsersReport />
        case QUERIES.AppsWithOneOwner:
            return <AppsWithOneOwnerReport />
        case QUERIES.AppsWithDeactivatedOwners:
            return <AppsWithDeactivatedOwnersReport />
        case QUERIES.AppResourcesWithDeactivatedOwner:
            return <AppResourcesWithDeactivatedOwnerReport />
        case QUERIES.PastGrants:
            return <PastGrantsReport />
        case QUERIES.ActiveExternalAccounts:
            return <ActiveExternalAccountsReport />
        default:
            return (
                <FormattedMessage
                    id="structured_search_report_not_implemented"
                    defaultMessage="To be implemented"
                />
            )
    }
}
